<template>
  <div
    class="absolute bg-surface-container-high dark:bg-surface-container-high -bottom-20 -left-1/2 -right-1/2 h-90 blur-md z-0 -rotate-6"
  ></div>
</template>
